import { render, staticRenderFns } from "./HGroupCenter.vue?vue&type=template&id=68e83243"
import script from "./HGroupCenter.vue?vue&type=script&lang=js"
export * from "./HGroupCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports